import * as React from 'react';
import TerminalInstallationListAddForm from './../Layout/Form/TerminalInstallationListAddForm';
import { News } from 'Redux/Actions/Models/ErrorActionModel';
import { setNewsForMoment } from 'Redux/Actions/ErrorActions';
import * as TIModule from 'Modules/TerminalInstallationModule';
import { connect } from 'react-redux';
import { withTranslation  } from 'react-i18next';

type Props = {
    history?: any;
};

type ConnectedDispatch = {
    createNew: Function;
    setNews: (news: News) => Function;
};

type ConnectedProps = {
    t: Function;
    userStore: TIModule.Types.TerminalInstallationStore;
};

type State = {};

class TerminalInstallationAdd extends React.Component<Props & ConnectedProps & ConnectedDispatch, State> {
    constructor(props: Props & ConnectedProps & ConnectedDispatch) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public async handleSubmit(formData: any) {
        const { createNew } = this.props;

        const newTerminalInstallationOrderData: TIModule.Types.CreateTerminalInstallationRequest = { ...formData };
        newTerminalInstallationOrderData['plannedAddress']['countryCode'] = 'PL';
        await createNew(newTerminalInstallationOrderData);
    }

    public render() {
        return (
            <div className="main__content main__content--scroll">
                <TerminalInstallationListAddForm
                    onSubmit={this.handleSubmit}
                    {...{
                        typeForm: 'add'
                    }}
                />
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        userStore: state.userStore
    };
}

function mapDispatchToProps(dispatch: any): ConnectedDispatch {
    return {
        createNew: (formData: TIModule.Types.CreateTerminalInstallationRequest) => dispatch(TIModule.Actions.createTerminalInstallationOrder(formData)),
        setNews: (news: News) => dispatch(setNewsForMoment(news))
    };
}

export default withTranslation (['forms', 'errors', 'dictionary'])(connect(
    mapStateToProps,
    mapDispatchToProps
)(TerminalInstallationAdd) as React.ComponentClass<any>);



// WEBPACK FOOTER //
// ./src/components/TerminalInstallation/TerminalInstallationAdd.tsx